module.exports = __webpack_public_path__ + "static/media/pond-from-top.a6bc5abe.png";